import React from "react";
import { ExpenseCashPayments } from "./ExpenseCashPayments";
import ExpenseBanksList from "src/components/Pages/Documents/ExpenseBanks/components/ExpenseBanksList";
import { IOutgoingBankPaymentOperationTypeEnum } from "src/components/Pages/Documents/ExpenseBanks/dtos/IOutgoingBankPaymentOperationTypeEnum";
import { IAppEntity } from "src/config/entities";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { ExpenseBanksDetail } from "src/components/Pages/Documents/ExpenseBanks/components/ExpenseBanksDetail";
import { NFLookupExpenseBankPayments } from "src/components/Shared/NewForms/NFLookupExpenseBankPayments";
import { ExpenseBanksService } from "src/services/documents/ExpenseBanksService";
import { ICreateExpenseBanksDto } from "src/components/Pages/Documents/ExpenseBanks/dtos/ICreateExpenseBanksDto";

export const ExpenseBankPayments: IAppEntity = {
  entityType: "document",
  title: "Outgoing Bank Payments",
  pluralTitle: "Outgoing bank payments",
  apiUrl: "ExpenseBankPayments",
  apiEnum: ReferenceTypes.DocumentExpenseBankPayment,
  getDetailView: (id?: string) => {
    return React.createElement(ExpenseBanksDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),

  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ExpenseBanksList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupExpenseBankPayments, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new ExpenseBanksService("ExpenseBankPayments"),
  getEmptyModel: () => {
    const model: ICreateExpenseBanksDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      documentNumber: "",
      status: 0,
      operationType: IOutgoingBankPaymentOperationTypeEnum.PaymentToVendor,
      dated: new Date(),
      createdDate: new Date(),
      processedDate: new Date(),
      payments: []
    };
    return model;
  }
};
